import React from 'react';
import { useTranslation } from 'react-i18next';

const SampleSickNote = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="py-2">
        <div className="container">
          <h2 className="center p-1">{t('Sample Sick Note')}</h2>
          <div className="bottom-line"></div>
          <p className="center mb-3">{t('How the Sick Note looks like')}</p>

          <div className="row">
            <div className="col-lg-12">
              <div className="sample-sicknote-container mb-3">
                <img
                  src="img/sicknote/Sample-Sick-Note-Void-ISM.png"
                  alt="Sample Sick Note from Richmond In-Store Medical Clinic"
                  className="img-fluid w-100"
                  style={{ border: '1px solid #ddd', borderRadius: '5px' }}
                />
              </div>
              <article className="card">
                <div className="center">
                  <p className="mt-3">
                    <span className="note">{t('This is a sample format.')}</span>{' '}
                    {t('Your actual sick note will include your specific information and medical details as provided by our licensed physicians.')}
                  </p>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SampleSickNote;
